export const ADD = "ADD"
export const RESET = "RESET"